module.exports = "../../../../platform/assets/pageMainIcon/business_baobiaochaxunlei8.svg";